import React, { Component } from 'react';
import { Guardian } from '@xaamin/guardian';
import { Link, Redirect, withRouter } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Navbar, Nav, NavDropdown, Container, Button } from 'react-bootstrap';

import './NavBarHeader.css';

import Str from '../../../support/Str';
import { Auth } from '../../../support';
import { resetStore } from '../../../store';
import { fetchAuthMe } from '../../../shared/session';
import Loading from '../../../facturotopia/loading/Loading';

function Title(props) {
  return <FontAwesomeIcon icon={['fas', 'plus-square']} />;
}

class NavBarHeader extends Component {
  state = {};

  constructor(props) {
    super(props);

    const { user } = Auth.getData();

    this.state = {
      user,
      toggle: 0,
      loggedIn: true,
      title: 'App',
      show: true,
    };

    window.setAppTitle = this.setAppTitle;
  }

  handleLogout = async () => {
    resetStore();

    setTimeout(async () => {
      await Auth.logout();

      this.setState({
        loggedIn: false,
      });
    }, 500);
  };

  pactopia = async () => {
    window.location.href = process.env.REACT_APP_PACTOPIA_FRONTEND_URL;
  };

  handleSessionRefresh = async () => {
    this.setState({
      busy: true,
    });

    try {
      const original = Auth.getData();

      const response = await fetchAuthMe();

      const user = {
        ...response.data,
        empresa: undefined,
        cliente: undefined,
        emisor: undefined,
      };

      const { empresa, emisor, cliente } = response.data;

      const data = {
        ...original,
        user,
        empresa,
        emisor: emisor || {},
        cliente: cliente || {},
      };

      await Auth.setData(data);

      this.setState({
        busy: false,
      });

      this.props.history.push('/bridge');
    } catch (error) {
      this.setState({
        busy: false,
      });

      window.ToastManager.show({
        variant: 'error',
        title: 'Error',
        message: error.message || 'Error al sincronizar tu sesión',
      });

      this.props.history.push('/bridge');
    }
  };

  setAppTitle = (title) => {
    this.setState({
      title,
    });
  };

  toggleSideBar = () => {
    this.props.onToggleSidebar();
  };

  render() {
    const { user, title, loggedIn, busy } = this.state;
    const { fluid } = this.props;

    if (!loggedIn) {
      return <Redirect to="/auth/login" />;
    }

    return (
      <Navbar
        className="navbar-header fa-navbar"
        bg="light"
        expand="lg"
      >
        <Container
          fluid={fluid}
          className="px-0"
        >
          <Navbar.Brand
            as="div"
            to="/app/dashboard"
          >
            <Button
              type="button"
              variant="link"
              className="d-inline d-lg-none d-xl-none"
              onClick={this.toggleSideBar}
            >
              <FontAwesomeIcon
                icon={['fas', 'bars']}
                className="menu-icon"
              />
            </Button>
            <span className="d-none d-lg-inline d-xl-inline px-3"></span>
            <span className="d-none d-sm-inline d-md-inline d-lg-inline d-xl-inline">{title}</span>
          </Navbar.Brand>
          <Nav>
            <NavDropdown
              title={<Title />}
              className="dropdown-toggle-no-icon"
              id="primary-actions-navbar"
              alignRight
            >
              {Guardian.allows('multiemisor.access') && (
                <NavDropdown.Item
                  as={Link}
                  to="/app/emisores/registrar"
                >
                  Nuevo Emisor
                </NavDropdown.Item>
              )}

              <NavDropdown.Item
                as={Link}
                to="/app/receptores/registrar"
              >
                Nuevo Receptor
              </NavDropdown.Item>

              {Guardian.allows('root.access') && (
                <>
                  <NavDropdown.Divider />

                  <NavDropdown.Item
                    as={Link}
                    to="/admin/pacs/registrar"
                  >
                    Nuevo Pac
                  </NavDropdown.Item>

                  <NavDropdown.Item
                    as={Link}
                    to="/admin/clientes/registrar"
                  >
                    Nuevo Cliente
                  </NavDropdown.Item>

                  <NavDropdown.Item
                    as={Link}
                    to="/cuenta/empresas/registrar"
                  >
                    Nueva Empresa
                  </NavDropdown.Item>
                </>
              )}
            </NavDropdown>

            {Guardian.allows('root.access') && (
              <Nav.Link
                as={Link}
                to="/admin/clientes"
              >
                <FontAwesomeIcon icon={['fas', 'shield-alt']} />
              </Nav.Link>
            )}

            <NavDropdown
              title={Str.only(user.nombre, 15)}
              id="basic-nav-dropdown"
              show={busy}
              alignRight
            >
              <NavDropdown.Item
                as={Link}
                to="/cuenta/perfil"
              >
                Mi cuenta
              </NavDropdown.Item>

              {Guardian.allows('account.api-keys') && (
                <NavDropdown.Item
                  as={Link}
                  to="/cuenta/keys"
                >
                  API keys
                </NavDropdown.Item>
              )}

              {Guardian.allows('empresa.intercambio') && (
                <NavDropdown.Item
                  as={Link}
                  to="/app/switch"
                >
                  Mis empresas
                </NavDropdown.Item>
              )}

              <NavDropdown.Item
                as={Link}
                to="/cuenta/licencia"
              >
                Mi licencia
              </NavDropdown.Item>

              <NavDropdown.Divider />

              <NavDropdown.Item onClick={this.handleSessionRefresh}>
                {!!busy ? <Loading className="mt-1 ml-3" /> : 'Sincronizar sesión'}
              </NavDropdown.Item>

              {Guardian.allows('is_connect.access') && (
                <NavDropdown.Item
                  as="div"
                  onClick={this.pactopia}
                >
                  Ir a Pactopia
                </NavDropdown.Item>
              )}

              <NavDropdown.Item
                as="div"
                to="/auth/logout"
                onClick={this.handleLogout}
              >
                Cerrar sesión
              </NavDropdown.Item>
            </NavDropdown>
          </Nav>
        </Container>
      </Navbar>
    );
  }
}

export default withRouter(NavBarHeader);
